import BankTable from "./BankTable";

export default BankTable;
